export const buildPrompt = (
  currentLocation,
  currentEvent,
  adventureLogs,
  rarity,
  quality
) => {
  const recentLogs = adventureLogs.slice(-3);
  const historySummaries = recentLogs
    .map((log) => `- ${log.summary}`)
    .join("\n");
  const allTags = [...new Set(recentLogs.flatMap((log) => log.tags || []))];

  return `
  You are tasked with generating a mysterious crafting material for the players.
  
  🎯 The material must have:
  - Rarity: ${rarity}
  - Quality: ${quality}
  
  You must strictly use the provided rarity and quality.
  
  🛠 Generate the material with this format:
  
  Material Name: [Generated Name]
  Short Description: [1–3 vivid sentences]
  Quality: [${quality}]
  Rarity: [${rarity}]
  
  (Optional) Add up to 3 sentences of lore if you wish.
  
  🧠 Context for World:
  
  - Current Location: ${currentLocation || "an unknown area"}
  - Current Situation: ${currentEvent || "No major event happening."}
  - Recent History:
  ${historySummaries || "- No recorded past events."}
  - World Themes: ${allTags.length > 0 ? allTags.join(", ") : "unknown themes"}
  
  ONLY produce 1 material. Keep it under 300 words.
  `.trim();
};
